import environment from '../../config/environment';
import api from '../../interceptors/axiosInterceptor';
import Cookies from 'js-cookie';

export const authService = {
  
  login: async (email, password) => {
    // Send real API request through interceptor
    const response = await api.post(`/User/Login`, {
      email,
      password
    });
    // Print the response in the console
   
    return response.data;
  },

  logout: async () => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    Cookies.remove('Token');
    sessionStorage.clear();
    // Also explicitly remove user to ensure it's cleared
    sessionStorage.removeItem('user');
    Cookies.remove('id');
    Cookies.remove('first_name');
    Cookies.remove('last_name');
    Cookies.remove('username');
    Cookies.remove('email');
    // window.location.href = '/login'; // Removed to avoid full page reload
    return { success: true };
  },

  forgotPassword: async (email) => {
    const response = await api.post('/User/ForgotPassword', { email });
    return response.data;
  },

  ResetPassword: async (Data) => {
    const response = await api.post('User/ResetPassword',Data);
    return response.data;
  }
}; 